import A from './types';

const initialState = {};

const reducer = (state, action) => {
  switch (action.type) {
    case A.TOGGLE_DROPDOWN: {
      return {[action.payload]: !state[action.payload]};
    }
    case A.CLOSE_DROPDOWN: {
      if (!state[action.payload]) {
        return null;
      }
      return {[action.payload]: false};
    }
    case A.OPEN_DROPDOWN: {
      if (state[action.payload]) {
        return null;
      }
      return {[action.payload]: true};
    }
  }

  return null;
};

export default {reducer, initialState};



// WEBPACK FOOTER //
// ./src/modules/dropdowns/reducer.js